import { Link } from 'react-router-dom';
import { hotRecommendations } from '@/mocks/home';

export default function HotRecommend() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              大家都在看的精彩内容，评分最高的精选推荐
            </p>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotRecommendations.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-background-50/70 text-xs">{item.category}</span>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400">{item.platform}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}